import { EndProductEmittingMethodInput } from '@/api/EmissionReportModel'
import { PreconsumerScrapMaterial } from '@/api/PreconsumerScrapMaterialModel'
import { PrecursorMaterial } from '@/api/PrecursorMaterialModel'

export default function validateActivityLevel(params: {
  activityLevel: number
  changeInStock: number
  waste: number
  precursorMaterials: PrecursorMaterial[]
  preconsumerScrapMaterials: PreconsumerScrapMaterial[]
  endProductEmittingMethodInputs: EndProductEmittingMethodInput[]
}) {
  const {
    activityLevel,
    changeInStock,
    waste,
    precursorMaterials,
    preconsumerScrapMaterials,
    endProductEmittingMethodInputs
  } = params

  const otherMaterialsAmmountInTonnes =
    endProductEmittingMethodInputs
      .filter(input => !input.deletedAt)
      .reduce((acc, curr) => acc + curr.quantityInTonnes, 0) || 0

  const precursorAmmountInTonnes = precursorMaterials.reduce(
    (acc, curr) => acc + curr.quantityInTonnes,
    0
  )
  const preConsumerScrapAmmountInTonnes = preconsumerScrapMaterials.reduce(
    (acc, curr) => acc + curr.quantityInTonnes,
    0
  )

  const totalInput =
    precursorAmmountInTonnes + preConsumerScrapAmmountInTonnes + otherMaterialsAmmountInTonnes
  const totalOutputExcludingConversions = activityLevel + changeInStock + waste

  const difference = totalInput - totalOutputExcludingConversions

  return {
    isValid: difference >= 0,
    error: {
      quantity: Math.abs(difference)
    }
  }
}
